import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Direction } from '../../types/direction';

const rotateMapping = {
  right: 'rotate(0deg)',
  left: 'rotate(180deg)',
  down: 'rotate(90deg)',
  up: 'rotate(270deg)',
};

@Component({
    selector: 'app-icon-arrow',
    templateUrl: './icon-arrow.component.html',
    styleUrls: ['./icon-arrow.component.scss'],
    standalone: false
})
export class IconArrowComponent implements OnChanges {
  @Input() color = '#021229';
  @Input() width = '14';
  @Input() height = '15';
  @Input() direction: Direction = 'right';
  rotate: string;

  getRotateMapping(direction: string) {
    return rotateMapping[direction] || rotateMapping.right;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.direction?.firstChange) {
      this.rotate = this.getRotateMapping(changes.direction?.currentValue);
    }
  }
}
